import { atom } from 'jotai';

import { Snackbar } from '../components/cookbook/Snackbars/types';

export const snackbarStateAtom = atom<Snackbar[]>([]);
